export enum Zoomer {
    off,
    interval_5_seconds,
    interval_10_seconds,
}
